// extracted by mini-css-extract-plugin
export default {"wrapper":"tab2_wrapper__h-IMG","flexis":"tab2_flexis__C72Fd","line":"tab2_line__lD58e","tr":"tab2_tr__yo+1O"};